import { render, staticRenderFns } from "./paperEdit.vue?vue&type=template&id=2394d81f&scoped=true&"
import script from "./paperEdit.vue?vue&type=script&lang=js&"
export * from "./paperEdit.vue?vue&type=script&lang=js&"
import style0 from "./paperEdit.vue?vue&type=style&index=0&id=2394d81f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394d81f",
  null
  
)

export default component.exports